import React from 'react';

import { AssessmentTestContext } from '../../contexts/assessment-test';

export const useActiveTestStep = () => {
  const [state] = React.useContext(AssessmentTestContext);
  if (state.screen.type !== 'STEP') {
    throw new Error('useActiveTestStep must be used within a STEP screen');
  }
  const stepId = state.screen.stepId;
  const sectionId = state.screen.sectionId;
  const stepIndex = state.screen.stepIndex;
  const step = state.steps[stepIndex];
  const section = step.sections.find((s) => s.id === sectionId);
  return { stepId, sectionId, stepIndex, step, section };
};
